import { getAuth, updatePassword } from 'firebase/auth';

import React, { useState } from 'react';
import { Row, Container, Card, Form } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import * as Sentry from '@sentry/react';
import { useClientUser } from '@/hooks';

function Password() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const { isSsoUser, isActingAsAccount } = useClientUser();

    const theme = createTheme({
        palette: {
            primary: {
                main: '#71b77a',
            },
        },
    });

    const submitPassword = (event) => {
        // updatePassword acts on the signed-in login, not this account's.
        if (isActingAsAccount) {
            return setMessage('Admins can not modify user passwords');
        } else if (password !== confirmPassword) {
            return setMessage('Passwords must match');
        }

        const auth = getAuth();
        const user = auth.currentUser;

        updatePassword(user, password)
            .then(() => {
                setPassword('');
                setConfirmPassword('');
                setMessage('Password Updated!');
            })
            .catch((error) => {
                let errMess = error.message.split(': ');
                setMessage('Error: ' + errMess[1]);
                Sentry.captureException(error);
            });

        event.preventDefault();
    };

    // updatePassword would attach a password credential to an SSO account. Removing the form is UX
    // only; enforcement is stripPasswordCredential plus ssoPasswordSweep, server-side.
    if (isSsoUser) {
        return (
            <Card className="tabCard">
                <Card.Body>
                    <Container fluid>
                        <h5 className="mb-1">Single sign-on</h5>
                        <p className="mb-0">
                            Your organization manages this account through single sign-on. Change your password with
                            your identity provider.
                        </p>
                    </Container>
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card className="tabCard">
            <ThemeProvider theme={theme}>
                <Card.Body className="">
                    <Container fluid>
                        <Form>
                            <Row className="d-flex flex-column mt-3">
                                <Form.Group>
                                    <h5 className="mb-1">Update Password</h5>
                                </Form.Group>
                            </Row>
                            <Row className="d-flex flex-column mt-3">
                                <Form.Group>
                                    <Form.Control
                                        name="passwordOne"
                                        type="password"
                                        className="password-height"
                                        placeholder="Password"
                                        onChange={(e) => setPassword(e.target.value)}
                                        value={password}
                                        style={{ width: '250px' }}
                                    />
                                </Form.Group>
                            </Row>
                            <Row className="d-flex flex-column my-1">
                                <Form.Group>
                                    <Form.Control
                                        name="passwordTwo"
                                        type="password"
                                        className="password-height"
                                        placeholder="Confirm Password"
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        value={confirmPassword}
                                        style={{ width: '250px' }}
                                    />
                                </Form.Group>
                            </Row>
                            <Row className="d-flex flex-column my-1">
                                <Form.Group>
                                    <Button
                                        onClick={submitPassword}
                                        className="my-1 account-btn"
                                        style={{ width: '250px' }}
                                    >
                                        Update
                                    </Button>
                                </Form.Group>
                            </Row>
                            {message && <div>{message}</div>}
                        </Form>
                    </Container>
                </Card.Body>
            </ThemeProvider>
        </Card>
    );
}

export default Password;
